import React from 'react';

// import "./RankLiskComponent.scss";

class RankListComponent extends React.Component {
	constructor() {
		super();
		this.state = {
			idx: 2
		};
	}

	componentDidMount() {
		// const loadMoreDataFn = this.loadMoreDataFn;
		// const that = this; // 为解决不同context的问题
		// let timeCount;
		// let dom = document.getElementById('rankListDom')
		//
		//
		// function callback() {
		// 	let oneDomHeight = document.querySelector('.rank-list-item').clientHeight
		// 	let allHeight = oneDomHeight * this.props.rankList.length
		// 	// console.log(dom.scrollTop + dom.clientHeight, allHeight, oneDomHeight, dom.scrollTop + dom.clientHeight + oneDomHeight);
		// 	// console.log(dom.scrollTop + dom.clientHeight + oneDomHeight + (oneDomHeight * idx) > allHeight);
		// 	if (dom.scrollTop + dom.clientHeight + oneDomHeight > allHeight) {
		// 		// 当 wrapper 已经被滚动到页面可视范围之内触发
		// 		loadMoreDataFn(that);
		// 	}
		// }
		//
		// dom.addEventListener('scroll', function (e) {
		// 	if (this.state.isLoadingMore) {
		// 		return ;
		// 	}
		// 	if (timeCount) {
		// 		clearTimeout(timeCount);
		// 	}
		// 	timeCount = setTimeout(callback.bind(this), 50);
		// }.bind(this), false);
	}

	loadMoreDataFn(that) {
		let idx = that.state.idx
		that.setState({
			idx: idx + 1
		}, () => {
			that.props.getRankList && that.props.getRankList(idx)
		})
	}

	// this.props.getRankList && this.props.getRankList(idx)

	render() {
		const rewardBgIcon = require('../../asstes/img/order/rank-icon.png')
		const {rankList, loginUserInfo} = this.props

		return <>
			<div className="rank-list" id={'rankListDom'}>
				{
					rankList.map((item, idx) => {
						if (!item.userCode && !item.score) {
							return <div className="rank-list-item flex-center-center" key={idx}>
								暂无数据
							</div>
						}
						return <div className="rank-list-item flex-center-center" key={idx}>
							<div className="rank-level flex-center-center">
								{ // userCode score
									idx < 3 ? <div className="relative">
											<img src={rewardBgIcon} alt=""/>
											<span className="reward-rank-idx flex-center-center">{idx + 1}</span>
										</div>
										: <span>{idx + 1}</span>
								}
							</div>
							<div className="rank-list-left flex-center-center">{item.userCode}</div>
							<div className="rank-list-right flex-center-center">送出{item.score}个祝福</div>
						</div>
					})
				}
			</div>
			<div className="user-rank-info flex-between-center">
				<span>我的排名</span>
				<span className="user-rank-info-left">{(loginUserInfo && loginUserInfo.ranking) || '0'}</span>
				<span className="user-rank-info-left">送出{(loginUserInfo && loginUserInfo.score) || 0}个祝福</span>
			</div>
		</>
	}
}

export default RankListComponent;
